import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from '../../types';
import { selectors as configSelectors } from '../../infrastructure/config';
import IDVChallengeErrorPage from './IDVChallengeErrorPage';
import { getUsername } from '../../infrastructure/cases/selectors';

class IDVChallengeError extends Component {
  render() {
    const { bankId, username } = this.props;
    return <IDVChallengeErrorPage bankId={bankId} username={username} />;
  }
}

IDVChallengeError.propTypes = {
  bankId: PropTypes.bankId
};

const mapStateToProps = state => ({
  bankId: configSelectors.bankId(state),
  username: getUsername(state)
});

export default connect(mapStateToProps)(IDVChallengeError);
